import { useCallback } from 'react';
import { IFiltersRef } from '../types/tables';

const useClearFiltersCallback = (filtersRef: React.RefObject<IFiltersRef> | null): (() => void) => {
  return useCallback(() => {
    const refPresent = filtersRef && typeof filtersRef !== 'function' && filtersRef.current;
    if (refPresent) {
      filtersRef.current?.resetFilters();
    }
  }, [filtersRef]);
};

export default useClearFiltersCallback;
